var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{attrs:{"input-value":_vm.darkTheme,"label":_vm.$t('config.dark-theme'),"inset":"","dense":""},on:{"change":_vm.onSelectTheme}})}
var staticRenderFns = []

export { render, staticRenderFns }